import * as Tabs from '@radix-ui/react-tabs';
import { useState } from 'react';
import { ArticleItemProps } from './constants';
import CategorizedArticle from './CategorizedArticle';


interface TabCategorizedArticleProps {
  latest?: Array<ArticleItemProps>;
  hot?: Array<ArticleItemProps>;
  Kehamilan?: Array<ArticleItemProps>;
  Menyusui?: Array<ArticleItemProps>;
  Parenting?: Array<ArticleItemProps>;
  Anak?: Array<ArticleItemProps>;
  viewport: string;
}

const TabCategorizedArticle = (props: TabCategorizedArticleProps) => {
  const { latest, hot, Kehamilan, Menyusui, Parenting, Anak, viewport } = props;
  const [activeTab, setActiveTab] = useState(latest && latest.length > 0 ? 'tab1' : 'tab3');

  return (
    <Tabs.Root
      className={`mb-6`}
      defaultValue={latest && latest.length > 0 ? 'tab1' : 'tab3'}
      onValueChange={(value) => setActiveTab(value)}
    >
      <Tabs.List className={`${viewport === "desktop" ? "" : "pl-6"} flex space-x-4 overflow-x-auto scrollbar-hide mb-6`}>
        {latest && latest.length > 0 && (
          <Tabs.Trigger value={`tab1`} className={`whitespace-nowrap text-xs py-2 px-4 font-poppins rounded-lg ${activeTab === `tab1` ? "text-white bg-mooimom" : "text-attributeBorder bg-topTextBg"}`}>
            What&apos;s New
          </Tabs.Trigger>
        )}
        {hot && hot.length > 0 && (
          <Tabs.Trigger value={`tab2`} className={`whitespace-nowrap text-xs py-2 px-4 font-poppins rounded-lg ${activeTab === `tab2` ? "text-white bg-mooimom" : "text-attributeBorder bg-topTextBg"}`}>
            Hot Articles
          </Tabs.Trigger>
        )}
        {Kehamilan && Kehamilan.length > 0 && (
          <Tabs.Trigger value={`tab3`} className={`whitespace-nowrap text-xs py-2 px-4 font-poppins rounded-lg ${activeTab === `tab3` ? "text-white bg-mooimom" : "text-attributeBorder bg-topTextBg"}`}>
            Kehamilan
          </Tabs.Trigger>
        )}
        {Menyusui && Menyusui.length > 0 && (
          <Tabs.Trigger value={`tab4`} className={`whitespace-nowrap text-xs py-2 px-4 font-poppins rounded-lg ${activeTab === `tab4` ? "text-white bg-mooimom" : "text-attributeBorder bg-topTextBg"}`}>
            Menyusui
          </Tabs.Trigger>
        )}
        {Parenting && Parenting.length > 0 && (
          <Tabs.Trigger value={`tab5`} className={`whitespace-nowrap text-xs py-2 px-4 font-poppins rounded-lg ${activeTab === `tab5` ? "text-white bg-mooimom" : "text-attributeBorder bg-topTextBg"}`}>
            Parenting
          </Tabs.Trigger>
        )}
        {Anak && Anak.length > 0 && (
          <Tabs.Trigger value={`tab6`} className={`whitespace-nowrap text-xs py-2 px-4 font-poppins rounded-lg ${activeTab === `tab6` ? "text-white bg-mooimom" : "text-attributeBorder bg-topTextBg"}`}>
            Tumbuh Kembang Anak
          </Tabs.Trigger>
        )}
      </Tabs.List>
      {latest && latest.length > 0 && (
        <Tabs.Content value={`tab1`} className="container mt-3">
          <CategorizedArticle articles={latest} tittle={null} link={null} limit={true} />
        </Tabs.Content>
      )}
      {hot && hot.length > 0 && (
        <Tabs.Content value={`tab2`} className="container mt-3">
          <CategorizedArticle articles={hot} tittle={null} link={null} limit={true} />
        </Tabs.Content>
      )}
      {Kehamilan && Kehamilan.length > 0 && (
        <Tabs.Content value={`tab3`} className="container mt-3">
          <CategorizedArticle articles={Kehamilan} tittle={null} link={null} limit={true} />
        </Tabs.Content>
      )}
      {Menyusui && Menyusui.length > 0 && (
        <Tabs.Content value={`tab4`} className="container mt-3">
          <CategorizedArticle articles={Menyusui} tittle={null} link={null} limit={true} />
        </Tabs.Content>
      )}
      {Parenting && Parenting.length > 0 && (
        <Tabs.Content value={`tab5`} className="container mt-3">
          <CategorizedArticle articles={Parenting} tittle={null} link={null} limit={true} />
        </Tabs.Content>
      )}
      {Anak && Anak.length > 0 && (
        <Tabs.Content value={`tab6`} className="container mt-3">
          <CategorizedArticle articles={Anak} tittle={null} link={null} limit={true} />
        </Tabs.Content>
      )}
    </Tabs.Root>
  ) 
}

export default TabCategorizedArticle;
